import * as React from 'react';
import { PropsWithChildren, useMemo } from 'react';
import { initialState, reducer } from 'state/reducers/alert';
import { AlertContext } from 'models/alertContext';
import { EAlertTime } from 'utils/date';

const timeouts: Record<string, ReturnType<typeof setTimeout>[]> = {};
export const AlertProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const clearAlert = (type: string) => {
    if (timeouts?.[type]) {
      timeouts?.[type].map((timeout) => clearTimeout(timeout));
    }
    dispatch({ type, payload: null });
  };
  const clearAlertTimeout = (
    type: string,
    time: EAlertTime = EAlertTime.SHORT,
    infinityAlert = false,
  ) => {
    if (infinityAlert) return () => {};
    const timeoutId = setTimeout(() => {
      clearAlert(type);
    }, time);
    if (!timeouts?.[type]) {
      timeouts[type] = [];
    }
    timeouts[type].push(timeoutId);

    return () => clearTimeout(timeoutId);
  };

  const setAlert = (type: string, payload: any, infinityAlert = false) => {
    dispatch({
      type,
      payload,
    });
    clearAlertTimeout(type, undefined, infinityAlert);
  };

  const value = useMemo(() => ({ ...state, setAlert, clearAlert }), [state]);

  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>;
};
